module.exports = __webpack_public_path__ + "482dfb9e03ef2ae0c433d78437eaab79.svg";